// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P8PU0","index":"styles_index__3u0q3"};